import AuthenticatedController from './AuthenticatedController';
import * as APIRoutes from '@mm/api-routes';
import { WhatsNewModel } from '../model/WhatsNewModel';
import { buildQueryString } from '@mm/utils';
import { Pagination } from '../store-interfaces';

type WhatsNewResponse = {
  entities: WhatsNewModel[];
  pagination: Pagination;
};

export class WhatsNewController extends AuthenticatedController {
  static retrieveAll(
    page: number = 1,
    perPage: number = 100,
  ): Promise<WhatsNewResponse> {
    const queryString = buildQueryString({
      per_page: perPage,
      page,
    });
    const url = `${APIRoutes.WhatsNew}${queryString}`;
    return super.get(url);
  }
}
